<template>
  <v-app class="page">
    <v-container fluid class="fill-height pa-0">
      <v-row class="fill-height">
        <!-- LEFT: Login Form -->
        <v-col
          cols="12"
          md="12"
          class="d-flex justify-center align-center pa-0"
        >
          <v-card class="pa-6" width="100%" max-width="600" flat>
            <!-- Logo -->
            <v-row justify="center" class="mb-6">
              <img :src="logo" height="80" contain />
            </v-row>
            <v-row justify="center" class="px-2 mb-6 text-center justify-cente">
              <v-alert
                v-if="loading"
                type="error"
                dense
                variant="tonal"
                border="bottom"
                class="my-2"
                icon="mdi-alert-outline"
              >
                {{ $t("verification_text") }}
                <v-progress-circular color="#D32F2F" indeterminate size="30" />
              </v-alert>
            </v-row>
            <v-row
              v-if="verification_success"
              justify="center"
              class="px-2 mb-6 text-center justify-cente"
            >
              <v-alert
                type="success"
                dense
                variant="tonal"
                border="bottom"
                class="my-2"
                icon="mdi-check-all"
              >
                {{ $t("success_verification_text") }}
              </v-alert>
            </v-row>
            <v-row justify="center" class="px-2 mb-6 text-center justify-cente">
              <v-alert
                v-if="alert.value"
                type="error"
                dense
                variant="tonal"
                border="bottom"
                class="my-2"
              >
                {{ alert.message }}
              </v-alert>
            </v-row>
            <!-- <v-form @submit.prevent="confirmEmail">
              <v-text-field
                v-model="reset_email"
                label="Email"
                type="email"
                prepend-inner-icon="mdi-email"
                autocomplete="off"
                required
                variant="solo"
                persistent-placeholder
              />
              <v-text-field
                v-model="reset_password"
                :type="showPassword ? 'text' : 'password'"
                :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                label="Password"
                prepend-inner-icon="mdi-lock"
                required
                variant="solo"
                persistent-placeholder
                @click:append-inner="showPassword = !showPassword"
              />
          <v-select
                v-model="language"
                :items="selectLanguage"
                item-title="lang"
                item-value="locale"
                label="Select Language"
                variant="solo"
                prepend-inner-icon="mdi-web"
                dense
                
              />

              <v-alert
                v-if="alert.value"
                type="error"
                dense
                variant="tonal"
                border="bottom"
                class="my-2"
              >
                {{ alert.message }}
              </v-alert>

              <v-alert
                v-if="alert_s.value"
                type="success"
                dense
                variant="tonal"
                border="bottom"
                class="my-2"
              >
                {{ alert_s.message }}
              </v-alert>

              <v-row justify="center" class="mt-4">
                <v-btn
                  :loading="loading"
                  color="red-darken-4"
                  dark
                  type="submit"
                  :disabled="!reset_email"
                  class="w-100"
                >
                  {{ $t("verify_account") }}
                  <v-icon end class="mx-1">mdi-progress-check</v-icon>
                </v-btn>
              </v-row>
            </v-form> -->
          </v-card>
        </v-col>

        <!-- RIGHT: Background image, only for md+ screens -->
        <!-- <v-col cols="12" md="3" class="d-none d-md-flex pa-0">
          <div
            class="bg-image"
            :style="{ backgroundImage: `url(${bgImage})` }"
          ></div>
        </v-col> -->
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import determineIpLocation from "../utils/determineIpLocation";
import logoImg from "@/assets/logo_dark.png";
import bg from "@/assets/login_background0.png";
import postRequest from "../api/postRequest";

export default {
  name: "Login",
  data() {
    return {
      logo: logoImg,
      bgImage: bg,
      showPassword: false,
      login: {
        email: "",
        password: "",
      },
      language: "it",
      selectLanguage: [
        { lang: "Italiano", locale: "it" },
        { lang: "English", locale: "en" },
      ],
      alert: { value: false, message: "" },
      alert_s: { value: false, message: "" },
      loading: true,
      reset_email: null,
      reset_password: null,
      verification_success: false,
      verification_error: false,
    };
  },
  watch: {},
  created() {
    this.$i18n.locale = "it";
    setTimeout(() => {
      this.confirmEmail();
    }, 4000);
  },
  methods: {
    async confirmEmail() {
      this.loading = true;
      postRequest
        .object("/user/verify-email", {
          token: this.$route.query.token,
          // email: this.reset_email,
          // password: this.reset_password,
        })
        .then((res) => {
          if (res.data.success === true) {
            this.loading = false;
            this.verification_success = true;
            setTimeout(() => {
              this.$router.push({ path: "/auth" });
              this.verification_success = false;
            }, 6000);
          } else {
            this.loading = false;
            this.alert.value = true;
            this.alert.message = res.data.message;
            this.verification_success = false;
            setTimeout(() => {
              this.alert.value = false;
              this.$router.push({
                path: "/auth",
                query: {
                  verification: `${res.data.message || "Something went wrong"}`,
                },
              });
            }, 5000);
          }
        })
        .catch((err) => {
          if (err) {
            this.loading = false;
            this.alert.value = true;
            this.alert.message =
              err.response.data.message || "Something went wrong";
            setTimeout(() => {
              this.alert.value = false;
              this.$router.push({
                path: "/auth",
                query: {
                  verification: `${err.response.data.message || "Something went wrong"} `,
                },
              });
            }, 4000);
          }
        });
      //   try {
      //     let data = {
      //       email: this.reset_email,
      //       password: this.reset_password,
      //     };
      //     const res = await this.axios.post(
      //       `${this.$serverUri}/api/users/verify-email`,
      //       data,
      //     );
      //     if (res.status === 200) {
      //       this.$router.push({ path: "/auth" });
      //     }
      //   } catch (error) {
      //     // console.log(error);
      //     this.alert.value = true;
      //     this.alert.message = "Something went wrong";
      //     setTimeout(() => {
      //       this.alert.value = false;
      //     }, 3000);
      //   } finally {
      //     this.loading = false;
      //   }
    },
    setLanguage() {
      determineIpLocation()
        .then((response) => {
          const { country } = response;
          switch (country) {
            case "IT":
              this.language = "it";
              this.$i18n.locale = "it";
              break;
            default:
              this.language = "it";
              this.$i18n.locale = "it";
              break;
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
html,
body,
#app {
  height: 100%;
  margin: 0;
}

.page {
  min-height: 100vh;
}

.bg-image {
  background-size: cover;
  background-position: center center;
  flex: 1;
}
</style>
